// =====================================================================
// src/lib/termo.js — o Termo de Adesão (0072), sem DOM
//
// O contrato com o Garvey (Anexo IV): proprietário e imobiliária de
// flats aceitam o Termo "por clique no primeiro acesso", com registro de
// nome ou razão social, CPF ou CNPJ, unidades, data, hora e IP. Decisão do
// Hugo (23/10/2026): Opção A, dentro do sistema.
//
// Quem trava é o banco (app.eu, 0072). Aqui só o que a tela decide: se o
// formulário pode ir, como mostrar o documento e o que dizer quando o
// texto mudou. A régua do documento é a do banco (app.cpf_valido e
// app.cnpj_valido); a tela confere antes só para avisar na hora.
// =====================================================================
import { cpfValido, cpfDigitos } from './usuarios.js';

export function cnpjValido(s) {
  const d = cpfDigitos(s);
  if (!/^\d{14}$/.test(d) || /^(\d)\1{13}$/.test(d)) return false;
  const dv = pesos => { let t = 0; pesos.forEach((p, i) => { t += Number(d[i]) * p; }); const r = t % 11; return r < 2 ? 0 : 11 - r; };
  return dv([5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2]) === Number(d[12]) && dv([6, 5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2]) === Number(d[13]);
}

export const documentoValido = s => { const d = cpfDigitos(s); return (d.length === 11 && cpfValido(d)) || (d.length === 14 && cnpjValido(d)); };

// 529.982.247-25 · 11.222.333/0001-81 · o resto como veio
export function formatarDocumento(s) {
  const d = cpfDigitos(s);
  if (d.length === 11) return `${d.slice(0, 3)}.${d.slice(3, 6)}.${d.slice(6, 9)}-${d.slice(9)}`;
  if (d.length === 14) return `${d.slice(0, 2)}.${d.slice(2, 5)}.${d.slice(5, 8)}/${d.slice(8, 12)}-${d.slice(12)}`;
  return String(s == null ? '' : s);
}

// O formulário: as mesmas mensagens do banco, na mesma ordem.
//
// 0073 (decisão do Hugo, 2B): o documento é o do CADASTRO do aderente — a
// tela o mostra só para leitura, e o banco recusa outro. Cadastro sem
// documento válido não aceita: quem corrige é o hotel. `cadastro` e
// `aderente` vêm de termo_para_aceite(); sem eles, vale a régua antiga.
export const cadastroSemDocumento = nome => `O cadastro de ${nome || 'este acesso'} está sem CPF ou CNPJ válido — peça ao hotel para corrigir antes do aceite`;
export function errosDoAceite({ nome, documento, li, cadastro, aderente }) {
  const erros = [];
  if (!String(nome || '').trim()) erros.push('Informe o nome ou a razão social');
  const doc = String(documento || '').trim();
  if (cadastro !== undefined && !documentoValido(cadastro)) erros.push(cadastroSemDocumento(aderente));
  else if (/[^\d.\-/\s]/.test(doc)) erros.push('CPF ou CNPJ tem só números (pontos, barra e traço podem ir)');
  else if (!documentoValido(doc)) erros.push('CPF ou CNPJ inválido — confira os dígitos');
  else if (cadastro !== undefined && cpfDigitos(doc) !== cpfDigitos(cadastro)) erros.push(`O CPF ou CNPJ não confere com o cadastro de ${aderente || 'este acesso'}`);
  if (!li) erros.push('Marque que leu e aceita o Termo');
  return erros;
}

// 0101: só a imobiliária adere — o dono não tem login, e `termos_aceites.tipo`
// passou a aceitar só 'imobiliaria' (a produção não tinha aceite de dono).
export const rotuloAderente = tipo => (tipo === 'imobiliaria' ? 'Imobiliária' : '—');

// O que a tela diz no topo
export function introducao(t) {
  if (!t) return '';
  const base = `Para usar o sistema do ${t.hotel}, leia e aceite o Termo de Adesão e Condições de Uso.`;
  return t.aceitou_antes ? `O Termo foi atualizado (versão ${t.versao}). ${base}` : base;
}

export function unidadesTexto(lista) {
  const u = Array.isArray(lista) ? lista : [];
  if (!u.length) return 'Nenhuma unidade vinculada a este acesso.';
  return (u.length === 1 ? 'Unidade ' : `${u.length} unidades: `) + u.join(', ');
}

// A tela de Usuários: quantos aceitaram a versão vigente
export function resumoDosAceites(situacao) {
  const a = (situacao && situacao.aderentes) || [];
  const emDia = a.filter(x => x.em_dia).length;
  return { total: a.length, emDia, pendentes: a.length - emDia };
}
